module.exports = __webpack_public_path__ + "assets/media/logo_substract.0ff9a199.svg";